import $api from 'http/index';
import { getOptions } from 'helpers/getOptions';
import { startOfDay, endOfDay } from 'date-fns';

export const fetchMaterialExportOptions = async (values) => {
  try {
    const searchParams = new URLSearchParams();

    if (values?.period?.from && values?.period?.to) {
      searchParams.append('from', startOfDay(values.period.from).toISOString());
      searchParams.append('to', endOfDay(values.period.to).toISOString());
    }
    if (values?.jobNumber?.length) searchParams.append('jobNumber', values.jobNumber.map((v) => v.replace(/,/, '\\,')).join(','));
    if (values?.cl?.length) searchParams.append('cl', values.cl.map((v) => v._id.replace(/,/, '\\,')).join(','));
    if (values?.materialName?.length) searchParams.append('materialName', values.materialName.map((v) => v.replace(/,/, '\\,')).join(','));
    if (values?.materialUnit?.length) searchParams.append('materialUnit', values.materialUnit.map((v) => v.replace(/,/, '\\,')).join(','));
    if (values?.materialColor?.length) searchParams.append('materialColor', values.materialColor.map((v) => v.replace(/,/, '\\,')).join(','));
    if (values?.materialSpecification?.length) searchParams.append('materialSpecification', values.materialSpecification.map((v) => v.replace(/,/, '\\,')).join(','));
    if (values?.lineWidth?.length) searchParams.append('lineWidth', values.lineWidth.join(','));
    if (values?.legendSymbol?.length) searchParams.append('legendSymbol', values.legendSymbol.map((v) => v.replace(/,/, '\\,')).join(','));
    if (values?.letteringText?.length) searchParams.append('letteringText', values.letteringText.map((v) => v.replace(/,/, '\\,')).join(','));
    if (values?.letteringParameters?.length) searchParams.append('letteringParameters', values.letteringParameters.map((v) => v.replace(/,/, '\\,')).join(','));
    
    const result = await $api.get(
      `${process.env.REACT_APP_BASE_URL}/submissions/materials/options`,
      {
        params: searchParams,
        ...getOptions()
      }
    );

    return result.data;
  } catch (err) {
    console.log(err);
  }
};
